var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup356(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.781 0.293466C13.39 -0.0978214 12.7561 -0.0978222 12.3652 0.293465L7.09291 5.57017L1.82815 0.300986C1.43719 -0.0903009 0.803318 -0.0903027 0.412359 0.300984C0.0214008 0.692272 0.0214011 1.32667 0.41236 1.71796L6.37681 7.68743C6.37951 7.69019 6.38223 7.69294 6.38497 7.69568C6.45601 7.76678 6.53507 7.82496 6.61924 7.87023C6.9983 8.07418 7.48098 8.01603 7.80096 7.69579C7.80595 7.69079 7.81089 7.68574 7.81576 7.68066L13.781 1.71044C14.1719 1.31915 14.1719 0.684753 13.781 0.293466Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup356);
export default __webpack_public_path__ + "static/media/Group 356.32ee0f4ebaa8226e106b63c1d6262905.svg";
export { ForwardRef as ReactComponent };